/* global ParamsData */
import Rgpd from "./rgpd";

export default () => {
    Rgpd((catId) => {

        window.consent = false;

        function gtag() {
            window.dataLayer.push(arguments);
        }


        window.gtag = gtag;

        let cookieinfos_json = localStorage.getItem('rgpd');
        if (cookieinfos_json != "") {

            let cookieinfos = JSON.parse(localStorage.getItem('rgpd'));
            if (catId === 'statistiques' && cookieinfos && typeof cookieinfos.statistiques !== 'undefined' && cookieinfos.statistiques === true) {
                window.consent = true;

                gtag('js', new Date());

                if (!ParamsData.is_portail) {
                    gtag('config', 'UA-164025359-1', {
                        anonymize_ip: true,
                        linker: {
                            domains: ['resonance.golf', 'boutique.resonance.golf', 'booking.resonance.golf', "'" + ParamsData.domain + "'",
                            ],
                            accept_incoming: true,
                        },
                    });
                }
                gtag('config', ParamsData.ga, {
                    anonymize_ip: true,
                    linker: {
                        domains: [
                            'resonance.golf', 'boutique.resonance.golf', 'booking.resonance.golf',
                        ],
                        accept_incoming: true,
                    },
                });
                if (ParamsData.is_portail) {
                    gtag('config', 'G-W6W7NB4RP9');

                    /* Facebook Pixel Code */
                    !function (f, b, e, v, n, t, s) {
                        if (f.fbq) return; n = f.fbq = function () {
                            n.callMethod ?
                                n.callMethod.apply(n, arguments) : n.queue.push(arguments)
                        };
                        if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
                        n.queue = []; t = b.createElement(e); t.async = !0;
                        t.src = v; s = b.getElementsByTagName(e)[0];
                        s.parentNode.insertBefore(t, s)
                    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

                    window.fbq = fbq;

                    fbq('init', '2825412757697340');
                    fbq('track', 'PageView');
                }
                /* Play Golf in France */
                let pgifScript = document.createElement("script");
                pgifScript.type = "text/javascript";
                pgifScript.src = "https://playgolfinfrance.centralweb.fr/script";
                document.body.append(pgifScript);
            }
        }
    });
};
